import type { ContractExtensionType, EmployerRelationshipTypes } from '@/types/Activity'

export const employerRelationshipMapping: Record<EmployerRelationshipTypes, string> = {
  HRDepartment: 'Human Resources Dept',
  LineManager: 'Line Manager',
  Unknown: 'N/A',
}

export const ContractExtensionMapping: Record<ContractExtensionType, string> = {
  HasExtension: 'Has Extension',
  NoExtension: 'No Extension',
  Unknown: 'N/A',
}
